import React, { useContext } from 'react'
import react from "../../assets/skills/react.png";
import js from "../../assets/skills/js.png"
import ts from "../../assets/skills/typescript.png"
import python from "../../assets/skills/python.png"
import bootstrap from "../../assets/skills/bootstrap.png"
import mongodb from "../../assets/skills/db.png"
import express from "../../assets/skills/express.png"
import figma from "../../assets/skills/figma.png"
import github from "../../assets/skills/github.png"
import git from "../../assets/skills/git.png"
import html from "../../assets/skills/html.png"
import css from "../../assets/skills/css.png"
import jquery from "../../assets/skills/jquery.png"
import tailwind from "../../assets/skills/tailwind.png"
import jwt from "../../assets/skills/jwt.png"
import material from "../../assets/skills/material.png"
import netlify from "../../assets/skills/netlify.png"
import node from "../../assets/skills/node.png"
import photoshop from "../../assets/skills/photoshop.png"
import postman from "../../assets/skills/postman.png"
import redux from "../../assets/skills/Redux.png"
import render from "../../assets/skills/render.png"
import socket from "../../assets/skills/socket.png"
import vite from "../../assets/skills/vite.png"
import vs from "../../assets/skills/vs.png"
import nextjs from "../../assets/skills/next.png"
import vercel from "../../assets/skills/vercel.png"
import canva from "../../assets/skills/canva.png";
import './skills.css'
import { UserContext } from '../../App';
import {motion} from 'framer-motion';
import {fadeIn} from '../variants'

function Skills() {
  const {theme,setTheme}=useContext(UserContext);
console.log(theme)
  return (
    <div style={{paddingTop:"2rem",paddingBottom:"5rem"}} className={theme==0?"skills-bg-light":"skills-bg-dark"}>
            <center>
        <h2 id={theme==0?"type-light":"type-dark"}>Skills</h2>
      </center>
    <div className='skills-main' >

      <div className='skills-container' style={{color:theme==0?'black':"white"}}>
        <motion.div
                      variants={fadeIn("up",0.2)}
                      initial="hidden"
                      whileInView={"show"}
                      viewport={{once:false,amount:0.7}}
         className='skills-section' id={theme==0?"card-light":"card-dark"}> 
            <h3>Languages</h3>
            <div className="name-section">
                <img className='icon' src={js} alt="javascript"/>
               
                <span className='name-js'>JavaScript</span>
                
                <img className='icon' src={ts} alt="typescript"/>
              
                <span className="name-ts">TypeScript</span>
                
                <img className='icon' src={python} alt="python"/>
                
                <span className="name-python" >Python</span>
                

            </div>
        </motion.div>
        <motion.div 
                      variants={fadeIn("up",0.2)}
                      initial="hidden"
                      whileInView={"show"}
                      viewport={{once:false,amount:0.7}}
        className='skills-section' id={theme==0?"card-light":"card-dark"}>
          <h3>JavaScript Libraries</h3>
          <div className="name-section">
            <img className='icon' src={react} alt="react" />  <span className='name-react'>React.js</span>
            <img className='icon' src={jquery} alt="jquery" /> <span className='name-jquery'>JQuery</span>
            <img className='icon' src={redux} alt="redux" /> <span className='name-redux'>Redux Toolkit</span>
          </div>
        </motion.div>
        <motion.div 
              variants={fadeIn("up",0.2)}
              initial="hidden"
              whileInView={"show"}
              viewport={{once:false,amount:0.7}}
        className='skills-section' id={theme==0?"card-light":"card-dark"}>
          <h3>UI & UX Design tools</h3>
          <div className="name-section">
            <img className='icon' src={figma} alt="figma"/> <span className='name-figma'>Figma</span>
            <img className='icon' src={photoshop} alt="photoshop" /> <span className='name-ps'>Photoshop</span>
            <img src={canva} className='icon' alt="canva" /> <span className='name-canva'>Canva</span>
          </div>
        </motion.div>

        <motion.div
                      variants={fadeIn("up",0.2)}
                      initial="hidden"
                      whileInView={"show"}
                      viewport={{once:false,amount:0.7}}
         className='skills-section' id={theme==0?"card-light":"card-dark"}>
            <h3>Backend and Libraries </h3>
            <div className="name-section">
              <img className='icon' src={node} alt="node" />  <span className='name-node'>Node.js</span>
              
              <img className='icon' src={jwt} alt="jwt" />  <span className='name-jwt'>JsonWebToken</span>
              <img className='icon' src={socket} alt="socketio"/><span className='name-socket'>Socket.io</span>
              <img className='db-icon' src={mongodb} alt="mongodb"/> <span className='name-db'>MognoDB</span>
              <img className='express-icon' src={express} alt="express"/> <span className='name-express'>Express</span>

            </div>
        </motion.div>
        <motion.div 
                      variants={fadeIn("up",0.2)}
                      initial="hidden"
                      whileInView={"show"}
                      viewport={{once:false,amount:0.7}}
        className='skills-section' id={theme==0?"card-light":"card-dark"}>
          <h3>Tools & Deployments</h3>
          <div className="name-section">
            <img className='icon' src={vs} alt="vscode" /> <span className='name-vs'>Visual Studio</span>
            <img className='icon' src={git} alt="git" /> <span className='name-git'>Git</span>
            <img className='icon' src={github} alt="github" /> <span className='name-github'>github</span>
            <img className='icon' src={postman} alt="netlify" /> <span className='name-netlify'>Netflify</span>
            <img src={netlify} alt="postman" className='icon' /> <span className='name-postman'>Postman</span>
            <img className='icon' src={vite} alt="vite" /> <span className='name-vite'>Vite</span>
            <img className='render-icon' src={render} alt="render" /> <span className='name-render'>Render</span>
            <img className='vercel-icon' src={vercel} alt="vercel" /> <span className='name-vercel'>Vercel</span>

            
          </div>
        </motion.div>
        <motion.div
                      variants={fadeIn("up",0.2)}
                      initial="hidden"
                      whileInView={"show"}
                      viewport={{once:false,amount:0.7}}
         className='skills-section' id={theme==0?"card-light":"card-dark"}>
          <h3>Frontend & Frameworks</h3>
            <div className="name-section">
              <img className='icon' src={html} alt="html" /> <span className='name-html'>HTML5</span>
              <img className='icon' src={css} alt="css" /> <span className='name-css'>CSS3</span>
              <img className='icon' src={tailwind} alt="tailwind" /> <span className='name-tailwind'>Tailwind</span>
              <img className='icon' src={bootstrap} alt="bootstrap" /> <span className='name-bootstrap'>Bootstrap</span>
              <img className='icon' src={material} alt="material-ui" /><span className='name-ui'>Material-UI</span>
              <img className='icon' src={nextjs} alt="nextjs" /><span className='name-next'>Next.js</span>
            </div>
        </motion.div>

      </div>
      
    </div>
    </div>
  )
}
export default Skills
